module.exports = __webpack_public_path__ + "static/img/lt.82b40bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shipIcons/mipmap-xxxhdpi/lt.png
// module id = KiHt
// module chunks = 18